import * as React from "react";
const SvgFiRrBracketRound = (props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <g clipPath="url(#fi-rr-bracket-round_svg__a)">
      <path
        fill="#062147"
        d="M14 24c-.22 0-.44-.07-.62-.22C13.16 23.6 8 19.39 8 12S13.16.39 13.38.22c.43-.35 1.06-.27 1.41.16.34.43.27 1.06-.16 1.41-.04.04-4.62 3.81-4.62 10.22s4.58 10.18 4.63 10.22a1.002 1.002 0 0 1-.63 1.78z"
      />
    </g>
    <defs>
      <clipPath id="fi-rr-bracket-round_svg__a">
        <path fill="#fff" d="M0 0h24v24H0z" />
      </clipPath>
    </defs>
  </svg>
);
export default SvgFiRrBracketRound;
